module.exports = __webpack_public_path__ + "static/media/self-employed.db090de0.jpg";